import { Heading, Text } from '@chakra-ui/react'
import Main from '@Marketing/Main'
import PostList from '@Marketing/PostList'
import data from '../posts/contentfulData'

const Blog = ({ posts, title, description /*, ...props */ }) => {
  return (
    <Main pageTitle={`${title} | Blog`} description={description} p={20}>
      <Heading>Welcome to my blog!</Heading>

      <Text className='description'>{description}</Text>

      <PostList posts={posts} />
    </Main>
  )
}

export default Blog

export async function getStaticProps() {
  const configData = await import(`@Marketing/siteconfig.json`)
  const posts = data.items

  return {
    props: {
      posts,
      title: configData.default.title,
      description: configData.default.title,
    },
  }

  // const posts = ((context) => {
  //   const keys = context.keys()
  //   const values = keys.map(context)

  //   const data = keys.map((key, index) => {
  //     let slug = key.replace(/^.*[\\\/]/, '').slice(0, -3)
  //     const value = values[index]
  //     const document = matter(value.default)
  //     return {
  //       frontmatter: document.data,
  //       markdownBody: document.content,
  //       slug,
  //     }
  //   })
  //   return data
  // })(require.context('../posts', true, /\.md$/))

  // return {
  //   props: {
  //     posts,
  //     title: configData.default.title,
  //     description: configData.default.description,
  //   },
  // }
}
